/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Ledger_Snapshot_Lot_InvalidInputs */

const vi_error_ledger_snapshot_lot_invalid = /** @type {(inputs: Error_Ledger_Snapshot_Lot_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã lô gửi kèm số lượng không hợp lệ. Tải lại sổ rồi ghi lại mẻ.`)
};

/**

* @param {Error_Ledger_Snapshot_Lot_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_ledger_snapshot_lot_invalid = /** @type {((inputs?: Error_Ledger_Snapshot_Lot_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Ledger_Snapshot_Lot_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_ledger_snapshot_lot_invalid(inputs)
});